module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_class-66d345e732890ea5fbab07399be83387.svg";